import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { APP_CONFIG } from '../config';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
  styleUrls: ['./contact-dialog.component.scss']
})
export class ContactDialogComponent implements OnInit {

  appConfig;

  constructor(public dialogRef: MatDialogRef<ContactDialogComponent>) {
    this.appConfig = APP_CONFIG;
  }

  ngOnInit() {
  }

}
